import { topicManagement } from "./topicManagement";
import { colors } from "../../stripeColors";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
import TopicContentIcon from "../../../components/Common/SvgIcons/OrganizeIcons/TopicContentIcon";
import { organize } from "./organize";
import PublishGroupTopicIcon from "../../../components/Common/SvgIcons/OrganizeIcons/PublishGroupTopicIcon";
import { seriesManagement } from "./seriesManagement";
import { FormattedMessage } from "react-intl";

export let addSeriesMgmt = {
  name: <FormattedMessage id="ADDNEWPROGRAM_TEXT" />,
  editName: "Edit Series",
  copyName: "Copy Series",
  editpath: (tenantName) =>
    `/${tenantName}/organize/seriesManagement/editSeries`,
  copypath: (tenantName) =>
    `/${tenantName}/organize/seriesManagement/copySeries`,
  path: (location, params, tenantName) =>
    location?.pathname.includes(addSeriesMgmt.editpath(tenantName))
      ? `${addSeriesMgmt.editpath(tenantName)}/${params?.seriesID}`
      : location?.pathname.includes(addSeriesMgmt.copypath(tenantName))
      ? `${addSeriesMgmt.copypath(tenantName)}/${params?.seriesID}`
      : `/${tenantName}/organize/seriesManagement/createNewSeries`,
  navLinks: (navigate, tenantName, location, params) => [
    {
      key: 1,
      label: <FormattedMessage id="PROGRAMMANAGEMENT_TEXT" />,
      path: `${seriesManagement.path(tenantName)}`,
      onClick: () => navigate(`${seriesManagement.path(tenantName)}`),
    },
    {
      key: 2,
      label: location?.pathname?.includes(addSeriesMgmt.editpath(tenantName))
        ? addSeriesMgmt.editName
        : location?.pathname?.includes(addSeriesMgmt.copypath(tenantName))
        ? addSeriesMgmt.copyName
        : addSeriesMgmt.name,
      path: `${location?.pathname}`,
    },
  ],

  tiles: (navigate, location, params, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DETAILS" />,
      path: `${addSeriesMgmt.path(location, params, tenantName)}/details`,
      color: colors.green,
      icon: (fill) => <DetailsIcon fill={fill} />,
      isCompleted: false,
      onClick: () =>
        navigate(`${addSeriesMgmt.path(location, params, tenantName)}/details`),
    },
    {
      key: 2,
      label: "Series Content",
      path: `${addSeriesMgmt.path(location, params, tenantName)}/seriesContent`,
      color: colors.purple,
      icon: (fill) => <TopicContentIcon fill={fill} />,
      isCompleted: false,
      onClick: () =>
        navigate(
          `${addSeriesMgmt.path(location, params, tenantName)}/seriesContent`
        ),
    },
    {
      key: 3,
      label: "Publish Series",
      path: `${addSeriesMgmt.path(location, params, tenantName)}/publishSeries`,
      color: colors.orange,
      icon: (fill) => <PublishGroupTopicIcon fill={fill} />,
      // isCompleted: false,
      onClick: () =>
        navigate(
          `${addSeriesMgmt.path(location, params, tenantName)}/publishSeries`
        ),
    },
  ],
};
